export default "<div class=\"loading-animator-page\"></div>";